import React from 'react'
import { Divider, Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { useAuthenticationLocaleText } from '../../text-localisation'

const StyledDivider = styled(Divider)`
  margin: 10px 0;
`
export const SignInDivider: React.FC = () => {
  const localiseText = useAuthenticationLocaleText()

  return (
    <Flex alignItems="center" gap={8} my={6}>
      <StyledDivider />
      <Text>{localiseText('auth_wizard.social_login.or')}</Text>
      <StyledDivider />
    </Flex>
  )
}
